import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { ExportStatus, ImportStatus } from '@src/types';
import { DatePicker, TrackableButton, useLocale, useSessionState } from 'pe-core-frontend';
import { useEffect, useMemo } from 'react';
export const RunsFilter = ({ type, onChange }) => {
    const { t } = useLocale();
    const [status, setStatus] = useSessionState(`${type}RunsStatus`, '');
    const [startDate, setStartDate] = useSessionState(`${type}RunsStartDate`, '');
    const [endDate, setEndDate] = useSessionState(`${type}RunsEndDate`, '');
    const statusOptions = useMemo(() => {
        return Object.values(type === 'import' ? ImportStatus : ExportStatus).map(key => ({
            label: t(`${type === 'import' ? 'ImportStatus' : 'ExportStatus'}.${key}`),
            value: key,
        }));
    }, [t, type]);
    useEffect(() => {
        onChange({ startDate, endDate, status });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate, status]);
    const handleReset = () => {
        setStatus('');
        setStartDate('');
        setEndDate('');
    };
    return (_jsxs(_Fragment, { children: [_jsx(Select, { easyPortal: true, className: 'w-full', value: status, onChange: e => setStatus(e.target.value), label: t('Status'), options: statusOptions }), _jsx(DatePicker, { label: t('Start Date'), value: startDate, onChange: setStartDate }), _jsx(DatePicker, { label: t('End Date'), value: endDate, onChange: setEndDate }), _jsx(TrackableButton, { btnType: 'mui', enText: 'Reset', tag: 'runs_filter', onClick: handleReset, variant: 'outlined', color: 'primary', children: t('Reset') })] }));
};
